import _ from 'lodash';
import React, { Component } from 'react';
import { Container, Header, Grid, Button, Icon, Sticky, Menu, Dimmer, Loader } from 'semantic-ui-react';
import ToastUtilities from './ToastUtilities';

import ApplicationSteps from './applicationParts/ApplicationSteps';
import Coverage from './applicationParts/Coverage';
import RatingDates from './applicationParts/RatingDates';
import ContactInfo from './applicationParts/ContactInfo';
import InsuredName from './applicationParts/InsuredName';
import ValidCoverageAndRatingError from './applicationParts/ValidCoverageAndRatingError';
import UserType from './applicationParts/UserType';
import MutualCompanies from './applicationParts/MutualCompanies';
import Quarter from './applicationParts/Quarter';
import ClassesAndWages from './applicationParts/ClassesAndWages';
import FinalValidation from './applicationParts/FinalValidation';
import Signature from './applicationParts/Signature';
import LoginRegisterModal from './applicationParts/LoginRegisterModal';
import resetStateToStep from './applicationParts/resetStateToStep';
import { get, del, post, put } from '../services/RestUtilities';
import AuthStore from '../stores/Auth';

const authUser = AuthStore.getUser();

const INITIAL_STATE = {
    step: 1,

    id: null,
    coverageId: '',
    insuredName: '',
    dueDate: '',
    dueDateExplanation: '',
    ratingDates: {},
    ratingPeriod: '',

    fullName: '',
    phoneNumber: '',
    emailAddress: '',

    insuredFullName: '',
    insuredPhoneNumber: '',
    insuredEmailAddress: '',

    userType: '',
    currentAgentOrAccountant: '',
    mutualCompanyAffiliated: '',
    mutualCompanyExplanation: '',
    quarter: '',

    authorizationFile: '',
    authorizationFileName: '',
    ownershipFile: '',
    ownershipFileName: '',
    correctionsFile: '',
    correctionsFileName: '',
    correctionsExplanation: '',

    nonOfficers: [],
    officers: [],

    hasValidCoverageAndRating: {},

    maxHourlyWage: 75,
    minHourlyWage: 5,
    maxAnnualWage: 0,
    minAnnualWage: 0,
    extremeWage: 500,

    signature: '',

    passedFinalValidations: false,
    finishedWithClassAndWage: false,
    contactBureauEmail: '',
    dueDatePassed: false,
    saving: false,
    loading: false,
    status: '',
    dueDateOverridden: false,
    ownershipOverridden: false,
    correctionsOverridden: false,
    needsToUpdateMutualCompanies: true,
    loginRegisterModalOpen: false,
    hasApplicableCPAPClasses: false,
};

const numberRegex = /^[0-9\b]+$/;

class Application extends Component {

    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    componentDidMount() {
        const applicationId = this.props.match.params.id;
        if (applicationId) {
            this.setState({ loading: true });
            get(`api/Application/GetApplicationJson?id=${applicationId}`)
                .then((response) => {
                    this.setState({ loading: false });
                    if (!response.isError) {
                        this.setState({ ...response.content });

                        if (response.content.dueDateOverridden && response.content.step < 2) {
                            this.setState({ step: 2 });
                        }
                        // This is to allow ratings to show up
                        if (response.content.step > 2) {
                            this.setState({ hasApplicableCPAPClasses: true });
                        }
                        if (response.content.ownershipOverridden && response.content.step < 5) {
                            this.setState({
                                mutualCompanyAffiliated: '',
                                mutualCompanyExplanation: '',
                                ownershipFile: '',
                                ownershipFileName: '',
                                step: 4
                            });
                        }
                        if (response.content.step > 5) {
                            this.getValidationBounds(response.content.quarter);
                        }
                        if (response.content.correctionsOverridden && response.content.step < 6) {
                            this.setState({ step: 6 });
                        }
                        if (response.content.finishedWithClassAndWage && response.content.passedFinalValidations && response.content.step >= 7) {
                            this.setState({ step: 7, finishedWithClassAndWage: true, passedFinalValidations: true });
                        }
                    } else {
                        ToastUtilities.error(response.errorContent.errorMessage);
                    }
                });
        }

        if (localStorage.getItem('applicationState') !== null) {
            var tempState = JSON.parse(localStorage.getItem('applicationState'));
            this.setState({ ...tempState });
            localStorage.removeItem('applicationState');

            if (this.props.authUser) {
                this.setState({
                    fullName: tempState.fullName || this.props.authUser.name,
                    phoneNumber: tempState.phoneNumber || this.props.authUser.phone,
                    emailAddress: tempState.emailAddress || this.props.authUser.email,
                });
            }
        } else {
            if (this.props.authUser) {
                this.setState({
                    fullName: this.state.fullName || this.props.authUser.name,
                    phoneNumber: this.state.phoneNumber || this.props.authUser.phone,
                    emailAddress: this.state.emailAddress || this.props.authUser.email,
                });
            }
        }

        fetch('api/Application/GetContactEmail')
                .then((response) => response.text())
                .then(data => {
                    this.setState({ contactBureauEmail: data });
                });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location !== prevProps.location) {
            this.setState({ ...INITIAL_STATE });
        }

        if (this.state.insuredName !== '' && this.state.step > prevState.step) {
            window.scroll(0, document.body.scrollHeight)
        }
    }

    backToTop = () => window.scroll({ top: 0, left: 0, behavior: 'smooth' });

    handleContextRef = contextRef => this.setState({ contextRef });

    handleCoverageIdChange = (e) => {
        if (e.target.value === '' || numberRegex.test(e.target.value)) {

            get(`api/Application/GetInsuredName?coverageId=${e.target.value}`)
                .then((response) => {
                    if (!response.isError) {
                        this.setState({ insuredName: response.content });
                    }
                });

            var temp = Object.assign({}, INITIAL_STATE);
            temp.coverageId = e.target.value;
            temp.contactBureauEmail = this.state.contactBureauEmail;
            temp.fullName = this.state.fullName;
            temp.phoneNumber = this.state.phoneNumber;
            temp.emailAddress = this.state.emailAddress;
            this.setState({ ...temp });
        }
    }

    handleInsuredNameConfirmClick = () => {
        get(`api/Application/GetRatingDates?coverageId=${this.state.coverageId}`)
            .then((response) => {
                if (!response.isError) {
                    this.setState({ ratingDates: response.content });
                    // We only check the construction classes if the ratings check succeeds
                    get(`api/Application/GetApplicableClassesForConstructionCredit?coverageId=${this.state.coverageId}`)
                        .then((response) => {
                            if (!response.isError) {
                                this.setState({ hasApplicableCPAPClasses: true });
                            } else {
                                this.setState({ hasValidCoverageAndRating: { result: false, errorMessage: response.errorContent.errorMessage } });
                            }
                        });
                } else {
                    this.setState({ hasValidCoverageAndRating: { result: false, errorMessage: response.errorContent.errorMessage }});
                }
            });   
    }

    handleRatingDateChange = (e, {value}) => {
        this.resetStateToStep(1);
        this.setState({ ratingPeriod: value });

        post('api/Application/HasValidCoverageAndRating', {
            coverageId: this.state.coverageId,
            ratingPeriod: value
        })
        .then((response) => {
            if (!response.isError) {
                if (response.content.result) {
                    this.setState({
                        hasValidCoverageAndRating: response.content,
                        step: 2,
                    });
                } else {
                    this.setState({
                        hasValidCoverageAndRating: response.content,
                        step: 1,
                    });
                }
            }
        });
    }

    handleContactInfoChange = (e) => {
        this.resetStateToStep(2);
        this.setState({ [e.target.name]: e.target.value });
    }

    handleInsuredContactInfoChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    setUserType = (e, {value}) => {
        this.resetStateToStep(3);
        if (value === 'Insured') {
            this.setState({
                userType: value,
                step: 4,
                insuredFullName: this.state.fullName,
                insuredPhoneNumber: this.state.phoneNumber,
                insuredEmailAddress: this.state.emailAddress,
                needsToUpdateMutualCompanies: true,
            });
        } else {
            this.setState({
                 userType: value,
            });
        }
    }

    setCurrentAgentOrAccountant = (e, {value}) => {
        if (value === 'Y') {
            this.setState({
                currentAgentOrAccountant: value,
                authorizationFileName: '',
                step: this.state.step + 1,
            });
        } else {
            this.setState({
                currentAgentOrAccountant: value,
                step: 3,
            });
        }
    }

    setMutualCompanyAffiliated = (e, {value}) => {
        if (value === 'Y' || this.state.ownershipOverridden) {
            this.setState({
                mutualCompanyAffiliated: value,
                step: this.state.step + 1,
            });
        } else {
            this.setState({
                mutualCompanyAffiliated: value,
                step: 4,
            });
        }
    }

    submitMutualCompanyApplication = () => {
        if (this.state.mutualCompanyExplanation === '') {
            return;
        }

        this.handleSubmit('REVIEW', 'OWNERSHIP');
    }

    setAuthorizationFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file) {
            this.setState({
                authorizationFile: file,
                step: this.state.step + 1,
             });
        } else {
            this.setState({ step: 3 });
        }
    }

    setOwnershipFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file) {
            this.setState({ ownershipFile: file });
        }
    }

    setCorrectionsFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file) {
            this.setState({ correctionsFile: file });
        }
    }

    handleSubmit = (saveReviewOrSubmit, reviewReason = null) => {
        this.setState({ saving: true });
        const { coverageId, signature, step, finishedWithClassAndWage, passedFinalValidations } = this.state;
        const applicationId = this.state.id;

        if (!coverageId) {
            ToastUtilities.error('You must at least include Coverage ID');
            this.setState({ saving: false });
            return;
        }

        if (!signature && step === 7 && finishedWithClassAndWage && passedFinalValidations) {
            ToastUtilities.error('You must sign the application.');
            this.setState({ saving: false });
            return;
        }

        if (this.props.authUser) {
            const formData = new FormData();
            let json = Object.assign({}, this.state);
            delete json.contextRef;
            formData.append('applicationJSON', JSON.stringify(json));
            formData.append('authorization', this.state.authorizationFile);
            formData.append('ownership', this.state.ownershipFile);
            formData.append('corrections', this.state.correctionsFile);
            formData.append('saveReviewOrSubmit', saveReviewOrSubmit);
            formData.append('reviewReason', reviewReason);

            post(`api/Application/Save?id=${(!applicationId ? null : applicationId)}`, formData)
                .then((response) => {
                    this.setState({ saving: false });
                    if (!response.isError) {
                        this.setState({ id: response.content.id });
                        ToastUtilities.success('Application Saved');

                        // If the application is submitted OR if a review of any kind
                        // Post back to main table
                        if (saveReviewOrSubmit === 'SUBMITTED' || saveReviewOrSubmit === 'REVIEW') {
                            this.props.history.push('/');
                        }
                    } else {
                        ToastUtilities.error(response.errorContent.errorMessage);
                    }
                });
        } else {
            this.setState({ saving: false, loginRegisterModalOpen: true });
            let json = Object.assign({}, this.state);
            delete json.contextRef;
            json.saving = false;
            json.loginRegisterModalOpen = false;
            localStorage.setItem('applicationState', JSON.stringify(json));
        }
    }

    handleLoginRegisterModalClose = () => this.setState({ loginRegisterModalOpen: false });

    handleClear = () => {
        this.setState({ ...INITIAL_STATE });
        this.backToTop();
    }

    handleDueDateExplanationChange = (e) => {
        this.setState({ dueDateExplanation: e.target.value });
    }

    handleMutualCompanyExplanationChange = (e) => {
        this.setState({ mutualCompanyExplanation: e.target.value });
    }

    handleCorrectionsExplanationChange = (e) => {
        this.setState({ correctionsExplanation: e.target.value });
    }

    resetStateToStep = (step) => {
        var temp = resetStateToStep(step, this.state);
        this.setState({ ...temp });
    }

    goToNextStep = () => {
        this.setState({ step: this.state.step + 1 });
    }

    handleQuarterChange = (e, data) => {
        this.setState({
            quarter: data.value,
            step: 6,
        });

        this.getValidationBounds(data.value);
    }

    getValidationBounds = (quarter) => {
        get(`api/Application/GetValidationBounds?quarter=${quarter}`)
            .then((response) => {
                if (!response.isError) {
                    this.setState({ ...response.content });
                }
            });
    }

    setNonOfficers = (nonOfficers) => {
        if (nonOfficers.length === 0) {
            this.setState({ step: 6 });
        } else {
            this.setState({ nonOfficers: nonOfficers });
        }
    }

    setOfficers = (officers) => {
        this.setState({
            officers: officers,
            passedFinalValidations: false,
            finishedWithClassAndWage: false
        });
    }

    handleNonOfficerTableUpdate = (e) => {
        if (e.target.name === 'hoursWorked' && (!numberRegex.test(e.target.value) && e.target.value !== '')) {
            return;
        }

        let item = {
            id: e.target.id,
            name: e.target.name,
            value: e.target.value
        };
        let isWholeTableFilledIn = true;

        let nonOfficers = this.state.nonOfficers.slice();
        let newNonOfficers = nonOfficers.map(nonOfficer => {
            for (let key in nonOfficer) {
                if (key === item.name && nonOfficer.id == item.id) {
                    nonOfficer[key] = item.value;
                }
                if (nonOfficer[key] === '') {
                    isWholeTableFilledIn = false;
                }
            }
            return nonOfficer;
        });

        if (isWholeTableFilledIn) {
            this.setState({
                nonOfficers: newNonOfficers,
                step: 7,
                passedFinalValidations: false,
                finishedWithClassAndWage: false,
            });

        } else {
            this.setState({
                nonOfficers: newNonOfficers,
                step: 6,
                passedFinalValidations: false,
                finishedWithClassAndWage: false,
            });
        }
    }

    handleOfficerTableUpdate = (e, data) => {
        if (data.name === 'hoursWorked' && (!numberRegex.test(data.value) && data.value !== '')) {
            return;
        }

        let item = {
            id: data.id,
            name: data.name,
            value: data.value
        };

        let officers = this.state.officers.slice();
        let newOfficers = officers.map(officer => {
            for (let key in officer) {
                if (key === item.name && officer.id === item.id) {
                    officer[key] = item.value;
                }
            }
            return officer;
        });

        this.setState({
            officers: newOfficers,
            passedFinalValidations: false,
            finishedWithClassAndWage: false,
        });
    }

    setFinalValidations = (passedFinalValidations, finishedWithClassAndWage, nonOfficers = null, officers = null) => {
        if (!passedFinalValidations) {
            this.setState({
                nonOfficers: nonOfficers,
                officers: officers,
            });
        }

        this.setState({
            passedFinalValidations: passedFinalValidations,
            finishedWithClassAndWage: finishedWithClassAndWage,
        });
    }

    handleSignatureChange = (e) => {
        this.setState({ signature: e.target.value });
    }

    downloadCPAPPDF = (id) => {
        let anchor = document.createElement("a");
        anchor.setAttribute('id', 'cpapApplicationPDF');
        document.body.appendChild(anchor);
        let headers = new Headers();
        headers.set('Authorization', `Bearer ${this.props.authUser.token}`);
        fetch(`api/Application/DownloadCCPAPReport?id=${id}`, { headers })
            .then((response) => response.blob())
            .then(blob => {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, 'CCPAP_Application.pdf');
                } else {
                    let objectUrl = window.URL.createObjectURL(blob);
                    anchor.href = objectUrl;
                    anchor.download = 'CCPAP_Application.pdf';
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                }
                let element = document.getElementById('cpapApplicationPDF');
                document.body.removeChild(element);
            });
    }

    downloadAttachment = (id, type, name) => {
        let anchor = document.createElement("a");
        anchor.setAttribute('id', 'cpapApplicationPDF');
        document.body.appendChild(anchor);
        let headers = new Headers();
        headers.set('Authorization', `Bearer ${this.props.authUser.token}`);
        fetch(`api/Application/DownloadForm?id=${id}&form=${type}`, { headers })
            .then((response) => response.blob())
            .then(blob => {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, 'CCPAP_Application.pdf');
                } else {
                    let objectUrl = window.URL.createObjectURL(blob);
                    anchor.href = objectUrl;
                    anchor.download = name;
                    anchor.click();
                    window.URL.revokeObjectURL(objectUrl);
                }
                let element = document.getElementById('cpapApplicationPDF');
                document.body.removeChild(element);
            });
    }

    changeNeedsToUpdateMutualCompanies = () => {
        this.setState({ needsToUpdateMutualCompanies: false });
    }

    render() {

        const {
            step,
            id,
            coverageId,
            insuredName,
            ratingDates,
            ratingPeriod,
            dueDateExplanation,
            fullName,
            phoneNumber,
            emailAddress,
            insuredFullName,
            insuredPhoneNumber,
            insuredEmailAddress,
            userType,
            currentAgentOrAccountant,
            mutualCompanyAffiliated,
            mutualCompanyExplanation,
            quarter,
            nonOfficers,
            officers,
            authorizationFileName,
            ownershipFileName,
            correctionsFileName,
            correctionsExplanation,
            hasValidCoverageAndRating,
            maxHourlyWage,
            maxAnnualWage,
            minAnnualWage,
            extremeWage,
            contextRef,
            signature,
            passedFinalValidations,
            finishedWithClassAndWage,
            contactBureauEmail,
            saving,
            loading,
            status,
            dueDateOverridden,
            ownershipOverridden,
            correctionsOverridden,
            needsToUpdateMutualCompanies,
            loginRegisterModalOpen,
            hasApplicableCPAPClasses,
        } = this.state;

        let alreadyHasBeenSaved = false;
        let readOnlyMode = false;
        if (id) {
            alreadyHasBeenSaved = true;
        }

        if (status === 'SUBMITTED' || status === 'REVIEW') {
            readOnlyMode = true;
        }

        return (
            <div ref={this.handleContextRef}>
                <Dimmer active={loading} inverted>
                    <Loader size='large'>Loading</Loader>
                </Dimmer>
                <LoginRegisterModal open={loginRegisterModalOpen} onClose={this.handleLoginRegisterModalClose} />
                <Grid columns={3}>
                    <Grid.Column computer={4} tablet={2} mobile={16}>
                        <ApplicationSteps step={step} contextRef={contextRef} status={status} />
                    </Grid.Column>
                    <Grid.Column computer={9} tablet={12} mobile={16} className='application-container'>
                        <Header as='h2' dividing inverted>New CCPAP Application</Header>
                        {step >= 1 && (
                                <Coverage
                                    step={step}
                                    onCoverageIdChange={this.handleCoverageIdChange}
                                    coverageId={coverageId}
                                    readOnlyMode={alreadyHasBeenSaved}
                                />
                            )
                        }
                        {insuredName !== '' && (
                                <InsuredName
                                    confirmed={hasValidCoverageAndRating.result}
                                    insuredName={this.state.insuredName}
                                    onConfirmClick={this.handleInsuredNameConfirmClick}
                                    contactBureauEmail={contactBureauEmail}
                                    readOnlyMode={alreadyHasBeenSaved}
                                />
                            )
                        }
                        {!_.isEmpty(ratingDates) && hasApplicableCPAPClasses && (
                            <RatingDates
                                ratingDates={ratingDates}
                                readOnly={readOnlyMode}
                                ratingPeriod={ratingPeriod}
                                onRatingDateChange={this.handleRatingDateChange}
                            />
                        )}
                        {(hasValidCoverageAndRating.result === false && !dueDateOverridden) && (
                                <ValidCoverageAndRatingError
                                    dueDatePassed={hasValidCoverageAndRating.dueDatePassed}
                                    errorMessage={hasValidCoverageAndRating.errorMessage}
                                    contactBureauEmail={contactBureauEmail}
                                    onDueDateReviewSubmit={this.handleSubmit}
                                    saving={saving}
                                    dueDateExplanation={dueDateExplanation}
                                    onDueDateExplanationChange={this.handleDueDateExplanationChange}
                                    readOnly={readOnlyMode}
                                />
                            )
                        }
                        {step >= 2 && (
                            <ContactInfo
                                step={step}
                                fullName={fullName}
                                phoneNumber={phoneNumber}
                                emailAddress={emailAddress}
                                onContactInfoChange={this.handleContactInfoChange}
                                goToNextStep={this.goToNextStep}
                                readOnly={readOnlyMode}
                            />
                        )}
                        {step >= 3 && (
                                <UserType
                                    applicationId={id}
                                    userType={userType}
                                    currentAgentOrAccountant={currentAgentOrAccountant}
                                    setCurrentAgentOrAccountant={this.setCurrentAgentOrAccountant}
                                    setUserType={this.setUserType}
                                    fileName={authorizationFileName}
                                    onFileChange={this.setAuthorizationFile}
                                    readOnly={readOnlyMode}
                                    downloadAttachment={this.downloadAttachment}
                                />
                            )
                        }
                        {step >= 4 && (
                            <MutualCompanies
                                applicationId={id}
                                coverageId={coverageId}
                                mutualCompanyAffiliated={mutualCompanyAffiliated}
                                setMutualCompanyAffiliated={this.setMutualCompanyAffiliated}
                                onMutualCompanyExplanationChange={this.handleMutualCompanyExplanationChange}
                                mutualCompanyExplanation={mutualCompanyExplanation}
                                submitMutualCompanyApplication={this.submitMutualCompanyApplication}
                                step={step}
                                goToNextStep={this.goToNextStep}
                                onFileChange={this.setOwnershipFile}
                                fileName={ownershipFileName}
                                readOnly={readOnlyMode}
                                ownershipOverridden={ownershipOverridden}
                                needsToUpdateMutualCompanies={needsToUpdateMutualCompanies}
                                changeNeedsToUpdateMutualCompanies={this.changeNeedsToUpdateMutualCompanies}
                                downloadAttachment={this.downloadAttachment}
                                saving={saving}
                            />
                        )}
                        {step >= 5 && (
                            <Quarter
                                quarter={quarter}
                                onQuarterChange={this.handleQuarterChange}
                                readOnly={readOnlyMode}
                                ratingPeriod={ratingPeriod}
                            />
                        )}
                        {step >= 6 && (
                            <ClassesAndWages
                                applicationId={id}
                                coverageId={coverageId}
                                insuredName={insuredName}
                                setNonOfficers={this.setNonOfficers}
                                nonOfficers={nonOfficers}
                                onNonOfficerTableUpdate={this.handleNonOfficerTableUpdate}
                                maxNonOfficerRate={maxHourlyWage}
                                extremeWage={extremeWage}
                                setOfficers={this.setOfficers}
                                officers={officers}
                                onOfficerTableUpdate={this.handleOfficerTableUpdate}
                                maxOfficerRate={maxAnnualWage}
                                minOfficerRate={minAnnualWage}
                                readOnly={readOnlyMode}
                            />
                        )}
                        {step >= 6 && !correctionsOverridden && (
                            <FinalValidation
                                nonOfficers={nonOfficers}
                                officers={officers}
                                maxRate={maxHourlyWage}
                                minPayroll={minAnnualWage}
                                maxPayroll={maxAnnualWage}
                                extremeWage={extremeWage}
                                goToNextStep={this.goToNextStep}
                                setFinalValidations={this.setFinalValidations}
                                passedFinalValidations={passedFinalValidations}
                                finishedWithClassAndWage={finishedWithClassAndWage}
                                correctionsFileName={correctionsFileName}
                                onFileChange={this.setCorrectionsFile}
                                correctionsExplanation={correctionsExplanation}
                                onCorrectionsExplanationChange={this.handleCorrectionsExplanationChange}
                                onSubmit={this.handleSubmit}
                                applicationId={id}
                                readOnly={readOnlyMode}
                                downloadAttachment={this.downloadAttachment}
                                saving={saving}
                            />
                        )}
                        {((step >= 7 && finishedWithClassAndWage && passedFinalValidations) || correctionsOverridden) && (
                            <Signature
                                signature={signature}
                                onSignatureChange={this.handleSignatureChange}
                                onSubmit={this.handleSubmit}
                                insuredContactInfo={{
                                    insuredFullName,
                                    insuredPhoneNumber,
                                    insuredEmailAddress
                                }}
                                onInsuredContactInfoChange={this.handleInsuredContactInfoChange}
                                saving={saving}
                                status={status}
                                readOnly={readOnlyMode}
                            />
                        )}
                    </Grid.Column>
                    <Grid.Column computer={3} tablet={2} mobile={16}>
                        <Sticky context={contextRef} offset={100}>
                            <Menu icon='labeled' vertical floated='right' style={{marginRight: '3em'}}>
                                {!readOnlyMode && (
                                    <Menu.Item onClick={() => this.handleSubmit('EDIT')} disabled={saving}>
                                        <Icon name='save' color='green' />
                                        Save
                                    </Menu.Item>
                                )}
                                {!alreadyHasBeenSaved && (
                                    <Menu.Item onClick={this.handleClear}>
                                        <Icon name='eraser' color='blue' />
                                        Clear
                                    </Menu.Item>
                                )}
                                {status === 'SUBMITTED' && (
                                    <Menu.Item onClick={() => this.downloadCPAPPDF(id)} target='_blank'>
                                        <Icon name='file pdf' color='teal' />
                                        Export
                                    </Menu.Item>
                                )}
                            </Menu>
                        </Sticky>
                        <Button className='back-to-top' icon='arrow circle up' floated='right' size='massive' onClick={this.backToTop}/>
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const ApplicationContainer = props => (
    <Container style={{ height: '100%' }} fluid>
        <Application {...props} authUser={authUser} />
    </Container>
);

export default ApplicationContainer;